var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"multi-select"},[_c('rich-button',{staticClass:"multi-select-btn",attrs:{"icon":"richic-select","outline":""},on:{"click":_vm.showPopup}},[_vm._v(_vm._s(_vm.showValue))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }